import styled from "styled-components";


export const Line = styled.div`
div {
  border-left: 2px solid;
  border-color: #915931
}
`;

export const Space = styled.div`
margin-bottom: 30%;
@media (max-width: 1100px) {

}
`;

export const Slides = styled.div`
height: 100vh;
@media (max-width: 600px) {
height: 50vh;
}
`;

export const Bottom = styled.div`
padding-left:3%;
padding-bottom:5%;
margin-bottom:5%;
`;

export const Logo = styled.img`
  width: 50%;
`;
